import { Project } from "@typedefs/interfaces";
import { FeatureCollection, getMapConfig } from "./mapMessages";
import { MAP_URL } from "./MapIframe";

/**
 * Builds the map configuration message for a given shape and project
 * @param shape - The GeoJSON FeatureCollection to display on the map
 * @param project - Optional project information
 * @returns The configuration object to send to the map
 */
export const buildConfigurationMessage = (
  shape: FeatureCollection | null,
  project?: Project,
  isBintact?: boolean
) => {
  return getMapConfig(shape, project, isBintact);
};

/**
 * Sends a configuration message to the map iframe
 * @param iframe - The iframe element containing the map
 * @param shape - The GeoJSON FeatureCollection to display on the map
 * @param mapUrl - The URL of the map (for postMessage origin)
 * @param project - Optional project information
 * @returns Promise that resolves when message is sent
 */
export const sendMapConfiguration = async (
  iframe: HTMLIFrameElement | null,
  shape: FeatureCollection | null,
  mapUrl: string,
  project?: Project,
  isBintact?: boolean
): Promise<void> => {
  if (!iframe?.contentWindow) {
    throw new Error("Iframe not initialized");
  }

  const configData = buildConfigurationMessage(shape, project, isBintact);
  console.log("PREFIX: Config data:", configData);

  try {
    // Extract origin from full URL for postMessage
    const targetOrigin = new URL(mapUrl).origin;
    iframe.contentWindow.postMessage(configData, targetOrigin);
    console.log("✅ sendMapConfiguration: Message sent successfully");
  } catch (err) {
    throw new Error(
      `Failed to send configuration: ${err instanceof Error ? err.message : String(err)}`
    );
  }
};

/**
 * Sends a configuration message to the map iframe using the default MAP_URL
 * @param iframe - The iframe element containing the map
 * @param shape - The GeoJSON FeatureCollection to display on the map
 * @param project - Optional project information
 * @returns Promise that resolves when message is sent
 */
export const sendMapConfigurationToExActMap = async (
  iframe: HTMLIFrameElement | null,
  shape: FeatureCollection | null,
  project?: Project
): Promise<void> => {
  return sendMapConfiguration(iframe, shape, MAP_URL, project, false);
};

